fragment CartProductFields on CartProduct {
  key
  quantity
  total
  option {
    name
    value
    type
  }
  product {
    id
    name
    model
    sku
    price
    original_price
    image
    imageLazy
    extra {
      name
      value
    }
    manufacturer {
      id
      name
      url(url: "/store/manufacturer/_id")
    }
    special
    isFinalSale
  }
}

# Mutations return the whole priced cart, so a line change also refreshes the
# subtotal and the coupon/total rows (a stale total after removing a line).
fragment CartTotalsFields on Cart {
  products {
    ...CartProductFields
  }
  total
  subtotal
  totals {
    code
    title
    value
    data
    sort_order
  }
}

mutation addToCart($id: String, $quantity: Int, $options: [CartOption]) {
  addToCart(id: $id, quantity: $quantity, options: $options) {
    ...CartTotalsFields
  }
}

mutation updateCart($key: String, $quantity: Int) {
  updateCart(key: $key, quantity: $quantity) {
    ...CartTotalsFields
  }
}

mutation removeCart($key: String) {
  removeCart(key: $key) {
    ...CartTotalsFields
  }
}

query cart {
  cart {
    ...CartTotalsFields
  }
}
